export const getUsernameHandle = (username: string): string => `@${username}`;
